'use es6';

import { fromJS, List } from 'immutable';
import { DESC } from 'reporting-data/constants/sortOrder';
import { TIME_SERIES, AGGREGATION } from 'reporting-data/constants/configTypes';
import { DATE, DATE_TIME } from 'reporting-data/constants/property-types';
import { Config } from 'reporting-data/config';
import getDefaultFrequency from '../../lib/getDefaultFrequency';
export function buildDrilldownReport(drilldownReport, grouping, dimensionProperty, metrics = List()) {
  const builtReport = drilldownReport.setIn(['config', 'dimensions'], fromJS([grouping])).setIn(['config', 'metrics'], metrics).setIn(['config', 'sort'], metrics && !metrics.isEmpty() ? fromJS([{
    property: metrics.first().get('property'),
    order: DESC
  }]) : undefined).deleteIn(['displayParams', 'hideKeyColumn']);
  if (dimensionProperty.get('type') === DATE || dimensionProperty.get('type') === DATE_TIME) {
    return builtReport.update('config', config => Config(config.set('configType', TIME_SERIES).toJS())).setIn(['config', 'frequency'], getDefaultFrequency(drilldownReport.getIn(['config', 'filters', 'dateRange'])));
  }
  return builtReport.setIn(['config', 'configType'], AGGREGATION);
}